import Button from '../../../../components/Button';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { DAY_OF_WEEK } from '../../constant';
import { VENDOR_LOGOS } from '^/constants/channel/logoImages.constants';
import { calculateHours } from '../../../../util/index';
import { useMediaQuery } from 'react-responsive';
import { GroupCar, NameCar } from '../../../../components/ModelCar';
import { borders } from '^/constants/commonStyles';
import { css } from '@emotion/css';
import { formatDateWithTimezone } from '../../../../util/dateFormat';
import locationNames from '^/constants/locationNames.constants';
import { parseRentDateTime } from '^/util/rentDateTime';
import { getCarName } from '^/util/getCarName';

const ReservationCard = ({ data, onButton, index }) => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  const pickUpDate = new Date(formatDateWithTimezone(data.pickup_datetime));
  const returnDate = new Date(formatDateWithTimezone(data.return_datetime));

  const { parsedPickupTime, parsedReturnTime, timeDiff } = parseRentDateTime(
    data.pickup_datetime,
    data.return_datetime,
    'YYYY.MM.DD (ddd) HH:mm',
  );
  const isOnlineTravel = data?.supplier == 'OT';

  if (isMobile) {
    return (
      <div
        className="flex flex-col bg-[#f4f4f4] p-[16px] rounded-[10px] gap-[15px]"
        onClick={(e) => {
          e.preventDefault();
          onButton(data);
        }}
      >
        {VENDOR_LOGOS[data.supplier] && (
          <div className="w-[116px] h-[25px] flex">
            <img
              alt="company-image"
              src={VENDOR_LOGOS[data.supplier]}
              className="object-scale-down"
            />
          </div>
        )}
        {/* 차량 모델 */}
        <p className="text-[16px] font-bold">
          [{t(data.size_car)}] {isOnlineTravel ? data?.car_model : getCarName(data?.car_model)}
        </p>
        <div className="flex flex-col gap-[15px]">
          <div className="flex flex-col gap-[5px]">
            <p className="text-default font-bold">예약 번호</p>
            <p className="text-small font-light">{data?.is_confirm_hertz ? data?.res_id : '-'}</p>
          </div>
          <div className={['flex flex-col gap-[5px]'].join(' ')}>
            <p className="text-default font-bold">대여/반납 장소</p>
            <p className="text-small font-light">
              {`${t(`location_name.${data.pickup_loc}`)} / ${t(
                `location_name.${data.return_loc}`,
              )}`}
            </p>
          </div>
          <div className="flex flex-col gap-[5px]">
            <p className="text-default font-bold">대여/반납 일시</p>
            <p className="text-small font-light">
              {`${parsedPickupTime} ~ ${parsedReturnTime} (${timeDiff})`}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {index !== 0 && isMobile && <div className="h-1.5 bg-trimo-bg -mx-6"></div>}
      <div className={'flex flex-col bg-white border border-[#D3D3D6] rounded-[10px] p-[30px]'}>
        <div className="flex flex-row h-[100%]">
          <div className="col-span-10 flex flex-col justify-between w-full">
            <div className={isMobile ? 'flex gap-2' : 'flex flex-col gap-2'}>
              <p className="text-[26px] font-bold">
                [{t(data.size_car)}]{' '}
                {isOnlineTravel ? data?.car_model : getCarName(data?.car_model)}
              </p>
            </div>
            {isMobile ? (
              <>
                <div className="flex flex-col gap-1.5">
                  <p className="text-default font-bold">예약 번호</p>
                  <p className="text-small font-light">
                    {data?.is_confirm_hertz ? data?.res_id : '-'}
                  </p>
                </div>
                <div className={['flex flex-col gap-1.5'].join(' ')}>
                  <p className="text-default font-bold">
                    대여/반납 장소{t('rentaled')} / {t('return')} {t('schedule')}
                  </p>
                  <p className="text-small font-light">
                    {`${parsedPickupTime} ~ ${parsedReturnTime} (${timeDiff})`}
                  </p>
                </div>
                <div className="flex flex-col gap-1.5">
                  <p className="text-default font-bold">대여/반납 일시</p>
                  <p className="text-small font-light">
                    {`${t(`location_name.${data.pickup_loc}`)} / ${t(
                      `location_name.${data.return_loc}`,
                    )}`}
                  </p>
                </div>
              </>
            ) : (
              <div className="flex justify-between mt-[22px]">
                <div className="flex flex-col gap-[10px]">
                  <div className="flex items-center">
                    <p className="font-bold  text-primary-gray w-[140px]">예약 번호</p>
                    <div className="text-big font-light">
                      {data?.is_confirm_hertz ? data?.res_id : '-'}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <p className="font-bold  text-primary-gray w-[140px]">대여/반납 장소</p>
                    <div className="text-default font-light">
                      {`${t(`location_name.${data.pickup_loc}`)} / ${t(
                        `location_name.${data.return_loc}`,
                      )}`}
                    </div>
                  </div>
                  <div className="flex items-center">
                    <p className="font-bold text-big  text-primary-gray w-[140px]">
                      대여/반납 일시
                    </p>
                    <div className="text-default font-light">
                      {/* yyyy.mm.dd (day) hh:mm ~ mm.dd (day) hh:mm (hours) */}
                      {`${parsedPickupTime} ~ ${parsedReturnTime} (${timeDiff})`}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-col flex-shrink-0 items-end justify-between">
            <div className="w-[116px] h-[25px] flex justify-end">
              {VENDOR_LOGOS[data.supplier] && (
                <img
                  alt="company-image"
                  src={VENDOR_LOGOS[data.supplier]}
                  className="object-scale-down"
                />
              )}
            </div>
            <Button
              color="secondarySkyblue"
              classNames="bg-primary-skyblue text-whiterounded-lg w-full py-[15px]"
              content="예약 상세보기"
              onClick={(e) => {
                e.preventDefault();
                onButton(data);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

ReservationCard.propTypes = {
  data: PropTypes.object.isRequired,
  onButton: PropTypes.func,
  index: PropTypes.number,
};

export default ReservationCard;
